import React from 'react';

import Img from '../../Img';
import styles from './emailInviteCard.scss';

const EmailInviteCard = ({ email, showRemoveButton, onRemoveEmail, 'data-testid': dataTestId }) => {
    const handleOnRemoveEmail = () => {
        onRemoveEmail(email);
    };

    return (
        <div className={styles.container}>
            <div className={`${styles.imageContainer} avatar-wrapper`}>
                <Img className={styles.image} alt="default icon" src="/img/v2/icons/icon-avatar-player.svg" />
            </div>
            <div className={styles.infoContainer}>
                <div className={styles.email} data-testid={dataTestId && `${dataTestId}.email`}>{email}</div>
            </div>
            {showRemoveButton && (
                <div className={styles.buttonContainer}>
                    <div className="close-icon" onClick={handleOnRemoveEmail} data-testid={dataTestId && `${dataTestId}.remove-btn`}><i className="utr utr-close" /></div>
                </div>
            )}
        </div>
    );
};

EmailInviteCard.defaultProps = {
    'data-testid': null,
};

export default EmailInviteCard;
